export enum Directions {
  Left,
  Right,

  Ascending,
  Descending,
}
